import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import DeployTrigger from "../../components/DeployTrigger";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Help from "../../components/Help";
import { helpPagesData } from "../../utils/helper";
import Paginate from "../../components/pagination";
import { Spinner } from "react-bootstrap";
import edit from "../../assets/pen1.svg";
import deleteicon from "../../assets/trash.svg";
import { useToast } from "../../components/ToastProvider";
import EmptyStateOrganization from "../../components/EmptyStateOrganization";
import CommonModal from "../../components/CommonModal";
import { fetchOrganizationList, deleteOrganization, UpdateOrganization } from "../../action/organizationaction";

const Organization = () => {
    const { showToast } = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    const [loadingButton, setLoadingButton] = useState(null);

    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(null);

    const [form, setForm] = useState({
        name: "",
        email: "",
        contact: "",
        password: "",
    });

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
    });

    const loadOrganizations = async () => {
        setLoader(true);
        const res = await fetchOrganizationList(pagination.page, pagination.limit);
        if (res?.status === 1) {
            setData(res.data.list);
            setPagination((p) => ({
                ...p,
                total: Math.ceil(res.data.total / p.limit),
            }));
        }
        setLoader(false);
    };

    useEffect(() => {
        loadOrganizations();
    }, [pagination.page, pagination.limit]);

    const handleEdit = (org) => {
        setSelectedOrg(org);
        setForm({
            name: org.name,
            email: org.email,
            contact: org.contact,
            password: "", // empty on UI
        });
        setEditModal(true);
    };

    const saveEdit = async () => {
        const res = await UpdateOrganization(selectedOrg._id, form);
        if (res?.status === 1) {
            showToast("Organization updated successfully", "success");
            setEditModal(false);
            loadOrganizations();
        } else {
            showToast(res?.message || "Update failed", "error");
        }
    };

    const confirmDelete = async () => {
        const res = await deleteOrganization(selectedOrg._id);
        if (res?.status === 1) {
            showToast("Organization deleted", "success");
            setDeleteModal(false);
            loadOrganizations();
        }
    };

    return (
        <>
            <PageHeader pageTitle="Organizations"> 
                    <Help
                        title={helpPagesData.pages.title}
                        message={helpPagesData.pages.message}
                        items={helpPagesData.pages.items}
                    />
                    <NavLink to="/organization/add-organization" className="btn-black">
                        Add Organization
                    </NavLink>
            </PageHeader>

            {loader ? (
                <div style={{ textAlign: "center", padding: "2rem" }}>
                    <Spinner size="md" />
                </div>
            ) : data.length === 0 ? (
                <EmptyStateOrganization />
            ) : (
                <div className="page-container">
                    <div className="theme-card p-4">
                        <div className="card-title pb-3">Overview</div>

                        <div className="table-responsive">
                            <table className="pages-table">
                                <thead>
                                    <tr>
                                        <th>Organization</th>
                                        <th>Email</th>
                                        <th>Contact</th>
                                        <th>Status</th>
                                        <th style={{ textAlign: "center" }}>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.map((org) => (
                                        <tr key={org._id}>
                                            <td>{org.name}</td>
                                            <td>{org.email}</td>
                                            <td>{org.contact || "-"}</td>
                                            <td>{org.is_active ? "Active" : "Inactive"}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <div className="three-btn">
                                                    <img src={edit} alt="icon" onClick={() => handleEdit(org)} />
                                                    <img src={deleteicon} alt="iconn" onClick={() => {
                                                        setSelectedOrg(org);
                                                        setDeleteModal(true);
                                                    }} />
                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {pagination.total > 1 && (
                                <Paginate
                                    currentPage={pagination.page}
                                    totalPages={pagination.total}
                                    onPageChange={(page) =>
                                        setPagination((p) => ({ ...p, page }))
                                    }
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* EDIT MODAL */}
            {editModal && (
                <CommonModal show={editModal} onClose={() => setEditModal(false)} width="450px">
                    <div class="card-header-title">Edit Organization</div>

                    <label className="frm-label">Name</label>
                    <input
                        className="frm-input"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                    />

                    <label className="frm-label mt-2">Email</label>
                    <input
                        className="frm-input"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />

                    <label className="frm-label mt-2">Contact</label>
                    <input
                        className="frm-input"
                        value={form.contact}
                        onChange={(e) => setForm({ ...form, contact: e.target.value })}
                    />

                    <label className="frm-label mt-2">Password</label>
                    <input
                        className="frm-input"
                        type="password"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                    />

                    <div className="modal-actions mt-3">
                        <button className="btn-white" onClick={() => setEditModal(false)}>
                            Cancel
                        </button>
                        <button className="btn-black" onClick={saveEdit}>
                            Update
                        </button>
                    </div>
                </CommonModal>
            )}

            {deleteModal && (
                <div className="popup-overlay">
                    <div className="popup-container">
                        <h4 className="popup-title">Delete Project?</h4>

                        <p className="popup-message">
                            Are you sure you want to delete <b>{selectedOrg?.name}</b>? This action cannot be undone.
                        </p>

                        <div className="popup-actions">
                            <button
                                className="btn-white"
                                onClick={() => setDeleteModal(false)}
                                disabled={loadingButton === "delete"}
                            >
                                No
                            </button>

                            <button
                                className="btn-red"
                                onClick={async () => {
                                    setLoadingButton("delete");
                                    await confirmDelete();
                                    setLoadingButton(null);
                                }}
                                disabled={loadingButton === "delete"}
                            >
                                {loadingButton === "delete" ? "Deleting..." : "Yes, Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default Organization;
